import { countryCodeEmoji } from 'country-code-emoji';
import { alpha3ToAlpha2, getName } from 'i18n-iso-countries';
import { FC } from 'react';

import { SearchConsoleAnalyticsCountriesDimension } from '@/modules/DomainsApi';

interface Props {
  value: SearchConsoleAnalyticsCountriesDimension['key'];
}

export const CountriesLabel: FC<Props> = ({ value }) => {
  const alpha2Value = alpha3ToAlpha2(value);

  return (
    <>
      <span>{
        alpha2Value
          ? countryCodeEmoji(alpha2Value)
          : '🏳️'
      }</span>
      &nbsp;
      <span>{ alpha2Value ? getName(alpha2Value, 'uk',) : 'Невідомий регіон' }</span>
    </>
  );
};
